import { useAppSelector } from '@/shared/hooks/redux';
import { parseJwt } from '@/shared/utils/authUtils';
import { capabilities, type Capability } from './capabilities';
import type { Role } from './roles';

/**
 * Extracts the Spring Security authorities from a decoded JWT.
 */
export const getAuthorities = (token: string | null): string[] => {
  if (!token) return [];
  const payload = parseJwt(token);
  return payload?.authorities ?? payload?.roles ?? [];
};

/**
 * Pure capability check: true when the token holds at least one of the
 * capability's allowed roles.
 */
export const can = (token: string | null, capability: Capability): boolean => {
  const authorities = getAuthorities(token);
  const allowedRoles = capabilities[capability] as readonly Role[];
  return allowedRoles.some((role) => authorities.includes(role));
};

/**
 * Hook resolving a capability against the logged user's token in Redux.
 */
export const useCan = (capability: Capability): boolean => {
  const token = useAppSelector((state) => state.auth.token);
  return can(token, capability);
};
